import React from 'react';
import { Award, Brain, CheckCircle2, Flame, Zap } from 'lucide-react';
import DashCard, { CardEmpty, CardLink } from '../shared/DashCard';

const BADGE_ICONS = { 'Quick Learner': Zap, 'AI Explorer': Brain, Consistent: CheckCircle2 };

const BADGE_FILLS = {
  violet: 'tw-from-chart-1 tw-to-chart-1/70',
  emerald: 'tw-from-success tw-to-success/70',
  amber: 'tw-from-warning tw-to-warning/70',
  rose: 'tw-from-danger tw-to-danger/70',
  sky: 'tw-from-info tw-to-info/70',
};

const Badge = ({ badge }) => {
  const Icon = BADGE_ICONS[badge.name] || Award;
  return (
    <li className="tw-flex tw-min-w-0 tw-flex-col tw-items-center tw-gap-2 tw-text-center">
      <span
        aria-hidden="true"
        className={`tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-bg-gradient-to-br tw-text-on-status [clip-path:polygon(50%_0%,95%_25%,95%_75%,50%_100%,5%_75%,5%_25%)] ${BADGE_FILLS[badge.color] || BADGE_FILLS.violet}`}
      >
        <Icon size={20} />
      </span>
      <span className="tw-line-clamp-2 tw-w-full tw-text-[0.6875rem] tw-font-semibold tw-leading-tight tw-text-content">{badge.name}</span>
    </li>
  );
};

/** Laid out to fit, so a badge is never cut off at the card's edge. */
const BadgesCard = ({ badges, showCertificates, className }) => (
  <DashCard
    title="Recent Badges"
    icon={<Flame size={16} aria-hidden="true" className="tw-text-chart-6" />}
    className={className}
    action={showCertificates ? <CardLink to="/s/self-paced/certificates">Certificates</CardLink> : null}
  >
    {badges.length > 0 ? (
      <ul className="tw-m-0 tw-grid tw-list-none tw-grid-cols-[repeat(auto-fill,minmax(72px,1fr))] tw-gap-x-2 tw-gap-y-3 tw-p-0">
        {badges.map((badge) => <Badge key={badge.id} badge={badge} />)}
      </ul>
    ) : (
      <CardEmpty>No badges yet. Keep learning to earn your first badge.</CardEmpty>
    )}
  </DashCard>
);

export default BadgesCard;
